import { Text, Grid, Box } from '@chakra-ui/react';
import { extractSlackDetails, extractMiscIntelDetails } from '../../utils/helpers';

interface MatchDetailsProps {
  match: any;
  API_URL: string;
  isCompact?: boolean;
}

export const MatchDetails = ({ match, isCompact = false }: MatchDetailsProps) => {
  const renderRiciDetails = () => (
    <>
      <Text fontSize={isCompact ? "sm" : "lg"} color="white" mt={2}>
        <Text as="span" fontWeight="bold" color="gray.300">Name:</Text> {match.details.name}
      </Text>
      <Grid templateColumns="auto 1fr" gap={2} w="full" mt={2}>
        <Text color="gray.300" fontSize={isCompact ? "xs" : "sm"} fontWeight="bold">DOB:</Text>
        <Text color="white" fontSize={isCompact ? "xs" : "sm"}>{match.details.dob}</Text>
        
        <Text color="gray.300" fontSize={isCompact ? "xs" : "sm"} fontWeight="bold">Booking Date:</Text>
        <Text color="white" fontSize={isCompact ? "xs" : "sm"}>{match.details.booking_date}</Text>
        
        <Text color="gray.300" fontSize={isCompact ? "xs" : "sm"} fontWeight="bold">Top Charge:</Text>
        <Text color="white" fontSize={isCompact ? "xs" : "sm"}>{match.details.top_charge}</Text>
      </Grid>
    </>
  );

  const renderFugitiveDetails = () => (
    <>
      <Text fontSize={isCompact ? "lg" : "2xl"} fontWeight="bold" color="white" mt={2}>
        {match.details.name}
      </Text>
      <Box 
        bg="red.600" 
        p={2} 
        borderRadius="md" 
        w="full"
        mt={2}
        fontSize={isCompact ? "xs" : "sm"}
      >
        <Text fontWeight="bold" color="white">
          Warrant #{match.details.warrant_number?.replace(/_/g, '-')}
        </Text>
      </Box>
    </>
  );

  const renderSlackDetails = () => {
    const details = extractSlackDetails(match.raw_image_path);
    const pageMatch = match.image_path.match(/_page(\d+)_/);
    const pageNumber = pageMatch ? parseInt(pageMatch[1]) + 1 : 'Unknown';

    return (
      <>
        <Text fontSize={isCompact ? "sm" : "lg"} color="white" mt={2}>
          <Text as="span" fontWeight="bold" color="gray.300">Slack Workspace:</Text> DPS-RTC
        </Text>
        <Grid templateColumns="auto 1fr" gap={2} w="full" mt={2}>
          <Text color="gray.300" fontSize={isCompact ? "xs" : "sm"} fontWeight="bold">Channel:</Text>
          <Text color="white" fontSize={isCompact ? "xs" : "sm"}>{details.channelName}</Text>
          
          <Text color="gray.300" fontSize={isCompact ? "xs" : "sm"} fontWeight="bold">File Name:</Text>
          <Text color="white" fontSize={isCompact ? "xs" : "sm"}>{details.fileName}</Text>
          
          <Text color="gray.300" fontSize={isCompact ? "xs" : "sm"} fontWeight="bold">Page Number:</Text>
          <Text color="white" fontSize={isCompact ? "xs" : "sm"}>{pageNumber}</Text>
          
          <Text color="gray.300" fontSize={isCompact ? "xs" : "sm"} fontWeight="bold">Date of Post:</Text>
          <Text color="white" fontSize={isCompact ? "xs" : "sm"}>{details.postDate}</Text>
        </Grid>
      </>
    );
  };

  const renderMiscIntelDetails = () => {
    const details = extractMiscIntelDetails(match.raw_image_path, match.image_path);
    return (
      <>
        <Text fontSize={isCompact ? "xs" : "sm"} color="white" mt={2}>
          <Text as="span" fontWeight="bold" color="gray.300">Document Name:</Text> {details.fileName}
        </Text>
        <Text fontSize={isCompact ? "xs" : "sm"} color="white">
          <Text as="span" fontWeight="bold" color="gray.300">Page Number:</Text> {details.pageNumber}
        </Text>
      </>
    );
  };

  switch (match.source) {
    case 'rici_database':
    case 'oj_bookings':
    case 'rockland_rici':
      return renderRiciDetails();
    case 'fugitive_database':
      return renderFugitiveDetails();
    case 'slack_mattermost_export':
      return renderSlackDetails();
    case 'misc_intel':
    case 'satg_suspects':
      return renderMiscIntelDetails();
    default:
      return null;
  }
}; 